import {
  $applyNodeReplacement,
  EditorConfig,
  ElementNode,
  LexicalEditor,
  LexicalNode,
  SerializedElementNode
} from 'lexical'

export class FillerNode extends ElementNode {
  static getType(): string {
    return 'filler'
  }

  static clone(_: SerializedElementNode): LexicalNode {
    return new FillerNode()
  }

  exportJSON(): SerializedElementNode {
    return {
      ...super.exportJSON(),
      type: FillerNode.getType()
    }
  }

  static importJSON(_serializedNode: SerializedElementNode): LexicalNode {
    return new FillerNode()
  }

  createDOM(_config: EditorConfig, _editor: LexicalEditor): HTMLElement {
    const span = document.createElement('span')
    span.className = _config.theme.filler
    span.innerHTML = '&#xFEFF;'
    return span
  }

  updateDOM(
    _prevNode: unknown,
    _dom: HTMLElement,
    _config: EditorConfig
  ): boolean {
    return false
  }

  isInline(): boolean {
    return true
  }

  canIndent(): boolean {
    return false
  }

  canInsertTextAfter(): boolean {
    return false
  }

  canInsertTextBefore(): boolean {
    return false
  }
}

export const $createFillerNode = () => {
  return $applyNodeReplacement(new FillerNode())
}

export const $isFillerNode = (node: LexicalNode): node is FillerNode => {
  return node instanceof FillerNode
}
